import dayjs from "dayjs";

export const DateRange = {
	empty: "empty",
	tomorrow: "tomorrow",
	today: "today",
	expired: "expired",
} as const;

export type DateRangeType = (typeof DateRange)[keyof typeof DateRange];

type DateRangeResult = {
	from: Date | null;
	to: Date | null;
};

export const getDateRangeByType = (type: DateRangeType): DateRangeResult => {
	let from = null;
	let to = null;

	switch (type) {
		case DateRange.empty: {
			break;
		}
		case DateRange.tomorrow: {
			from = dayjs().add(1, "day").startOf("day");
			to = dayjs().add(1, "day").endOf("day");
			break;
		}
		case DateRange.today: {
			from = dayjs().startOf("day");
			to = dayjs().endOf("day");
			break;
		}
		case DateRange.expired: {
			to = dayjs().subtract(1, "day").endOf("day");
			break;
		}
	}

	return {
		from: from ? from.toDate() : null,
		to: to ? to.toDate() : null,
	};
};
